<template>
  <section class="aspect defaultSectionPaddings brandBackgroundColor" :class="brandData ? useCamelCase(brandData.theme_class) : null">
    <div class="container">
      <h2 v-text="data.title" />

      <div class="aspect__Content">
        <div class="aspect__ImageWrapper">
          <template v-for="(item, index) in ['left_small_image', 'right_small_image', 'image']">
            <FlarePicture
              v-if="data[item]"
              :src="{
                1920: { src: data[item], width: index > 1 ? 644 : 310, height: index > 1 ? 520 : 310, size: 'both', crop: 'fill' },
              }"
              :alt="data[item]"
            />
          </template>
        </div>

        <div v-if="data.description" v-html="data.description" class="aspect__Texts" />
      </div>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {},
  });

  const { page } = usePage();
  const { initialData } = useSetup();
  const brandData = initialData.value.brands.find(brand => brand.id === page.value.id);
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_aspect.scss');
</style>